import { render, staticRenderFns } from "./StandInfoForm.vue?vue&type=template&id=3956e93e&"
import script from "./StandInfoForm.vue?vue&type=script&lang=js&"
export * from "./StandInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports